import { fromJS } from 'immutable'
import * as actions from 'actions/feature/notes'
import { set, update, unshift } from 'utils/immutable'

export default {
  [actions.NOTES_RECEIVED]: updateNotes,
  [actions.NOTE_ADDED]: addNote,
  [actions.RESET_NOTES]: resetNotes,
  [actions.DELETE_NOTES]: deleteNotes,
}

function updateNotes(state, { data }) {
  return set('notes', data, state)
}

function addNote(state, { data }) {
  return update('notes', unshift(fromJS(data)), state)
}

function deleteNotes(state, { noteIds }) {
  return update(
    'notes',
    (notes) => notes.filter((note) => !noteIds.includes(note.get('id'))),
    state
  )
}

function resetNotes(state) {
  return set('notes', [], state)
}
